import { Component, OnInit, Input, Inject, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { AbstractComponent } from '../../../../../core/common/component/AbstractComponent';
import { GSVideoClipDialogService } from './GSVideoClipDialogService';

@Component({
  selector: 'gs-video-clip-dialog',
  templateUrl: './GSVideoClipDialog.html',
  styleUrls: ['./GSVideoClipDialog.scss'],
})
export class GSVideoClipDialogComponent extends AbstractComponent {

  
  public clipForm: FormGroup;
  public scope = {
    message : '',
  }
  

  constructor(
     @Inject(MAT_DIALOG_DATA) 
     private parameter: any,
     private matDialogRef : MatDialogRef<GSVideoClipDialogComponent>,
     private service : GSVideoClipDialogService,
     private formBuilder: FormBuilder) {
    super();
    // this.toasterService = toasterService;
  }
  public componentWillMount() {
    console.log(this.parameter)
    this.clipForm = this.formBuilder.group({
    });
  }

  public onSubmit() {
  }
}
